<template>
  <div class="col-md-12 roster-la-reports">
    <b-overlay :show="loading" rounded="sm">
      <div class="clearfix row py-2 mb-2 no-margin">
        <div class="col-md-5 pr-0 cursor-pointer text-left pl-0">

          <b-input-group class="from_date-range-picker d-flex flex-row align-items-end justify-content-start">
            <b-form-group id="from_date-group" label-for="from_date" class="mb-0 mr-3"  label="From Date">
              <b-input-group class="mb-0">
                <b-form-input id="from_date" name="from_date" v-model="from_date" v-validate="{  }" type="text" placeholder="YYYY-MM-DD"
                              autocomplete="off" :state="validateState('from_date')" aria-describedby="from_date-feedback" data-vv-as="From Date"/>
                <b-input-group-append class="mb-0">
                  <b-form-datepicker v-b-tooltip.hover.top="'Select a date to preview the report.'" @input="reset" class="mb-0" id="day_two" button-only right locale="en-US" v-model="from_date" />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group id="to_date-group" label-for="to_date" class="mb-0" label="To Date">
              <b-input-group class="mb-0">
                <b-form-input id="to_date" name="to_date" v-model="to_date" v-validate="{  }" type="text" placeholder="YYYY-MM-DD"
                              autocomplete="off" :state="validateState('to_date')" aria-describedby="to_date-feedback" data-vv-as="To Date"/>
                <b-input-group-append class="mb-0">
                  <b-form-datepicker :max="new Date()" v-b-tooltip.hover.top="'Select a date to preview the report.'" @input="reset" class="mb-0" id="day_two" button-only right locale="en-US" v-model="to_date" />
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-input-group>


        </div>
        <div class="col-md-7 no-margin p-0">
          <div class="row d-flex justify-content-end no-margin">
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="reset()">Reset</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="previewOrDownloadReport(0)">Preview Report</b-button>
            <b-button variant="secondary" class="d-flex justify-content-end m-1" @click="previewOrDownloadReport(1)">Download Report (Excel)</b-button>
          </div>
        </div>
      </div>

      <div v-if="preview" class="monthly-report-wrap">
        <table class="table roster-la-report-table">
          <thead class="table-head">
          <tr>
            <th class="position-sticky">SL</th>
            <th class="position-sticky">Employee Code</th>
            <th class="position-sticky">Employee Name</th>
            <th class="position-sticky">Designation</th>
            <th class="position-sticky">Department</th>
            <th class="position-sticky">Work Location</th>
            <th>Working Day</th>
            <th v-if="roster == 1">Unassigned Day</th>
            <th>Present</th>
            <th>Late</th>
            <th>Early Out</th>
            <th>Incomplete Days</th>
            <th>Leave</th>
            <th>Absent</th>
            <th>Holiday</th>
            <th>Off Day</th>
            <th>Expected Duty(H)</th>
            <th>Actual Duty(H)</th>
            <th>Average Duty(H)</th>
            <th>Late(H)</th>
            <th>Early(H)</th>
            <th>Incomplete Hours(H)</th>
            <th>Extra Duty(H)</th>
          </tr>
          </thead>

          <tbody v-if="rows.length">
          <tr v-for="r in rows" :key="r.employee_code + '_' + r.serial_no">
            <td class="bg-white position-sticky">{{ r.serial_no }}</td>
            <td class="bg-white position-sticky">{{ r.employee_code }}</td>
            <td class="bg-white position-sticky">{{ r.employee_name }}</td>
            <td class="bg-white position-sticky">{{ r.designation }}</td>
            <td class="bg-white position-sticky">{{ r.department }}</td>
            <td class="bg-white position-sticky">{{ r.branch }}</td>
            <td>{{ r.working_day }}</td>
            <td v-if="roster == 1">{{ r.unassigned_day }}</td>
            <td>{{ r.present }}</td>
            <td>{{ r.late }}</td>
            <td>{{ r.early_out }}</td>
            <td>{{ r.incomplete_days }}</td>
            <td>{{ r.leave }}</td>
            <td>{{ r.absent }}</td>
            <td>{{ r.holiday }}</td>
            <td>{{ r.weekend }}</td>
            <td>{{ r.expected_duty }}</td>
            <td>{{ r.actual_duty }}</td>
            <td>{{ r.average_duty }}</td>
            <td>{{ r.late_h }}</td>
            <td>{{ r.early_h }}</td>
            <td>{{ r.incomplete_hours }}</td>
            <td>{{ r.extra_duty }}</td>
          </tr>
          </tbody>

          <tbody v-else>
          <tr>
            <td colspan="21" class="text-center py-4">No data</td>
          </tr>
          </tbody>
        </table>
      </div>


      <div v-else class="row" id="assignment">
        <div class="col-12">
          <b-badge class="d-inline mb-3" variant="info">Selected Employee: {{employee_ids.length}}</b-badge>
          <div class="card border-0 no-shadow">
            <common-list :checkbox="1" :is_action="0" :appended_column="appended_column" :key="list_key" :company_options="company_options" :employees="custom_list"
                         :all_employee="'no'" :default_column="default_column" :primary_key="'employee_id'" v-on:childToParent="listReturn"></common-list>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
export default {
  data() {
    const now = new Date();
    let firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    let lastDay = new Date();

    let format = function(d){
      let year = d.getFullYear();
      let month = ('0' + (d.getMonth() + 1)).slice(-2);
      let day = ('0' + d.getDate()).slice(-2);
      return year + '-' + month + '-' + day;
    };
    return {
      loading: false,
      preview: false,
      company_options:[],
      list_key:0, /* Component Key */
      custom_list:[],  /* Data List */
      default_column:['name','phone','email','jobposition','department','branch','leave_policy','leave_type'], /* Default Column List */
      appended_column:[],
      employee_ids:[],
      rows: [],
      from_date: format(firstDay),
      to_date: format(lastDay),
      roster:0,
    };
  },

  methods: {
    listReturn:function(data)
    {
      this.employee_ids = data.selected;

    },
    getCompanyLeaveSettings: function () {
      if (!this.checkNet()) return false;
      axios
        .get(this.$api_url + "/front/leave-attendance/company/leave/settings")
        .then(
          function (response) {
            if (response.data.length != 0) {
              this.roster = response.data.roster;
            }
          }.bind(this)
        );
    },
    reset(){
      this.preview = false;
      this.employee_ids = [];
      this.list_key++;
      this.getEmployees();
    },
    getEmployees() {
      axios.get(this.$api_url + '/leave-attendance/employees/list', { params: {all: this.all,fields:'offday,roster,shift',from:this.from_date, to: this.to_date}}).then(response => {
        this.showoverlay = false;
        if(response.data.error == 1)
          this.notice = response.data.notice;
        else
        {
          this.custom_list = response.data.employee_data;
          this.company_options = response.data.options;
          this.list_key = this.list_key + 1;

        }
      }).catch(e => {
        this.serverError(e);
      });
    },
    previewOrDownloadReport(flg) {
      if(!this.checkNet()) return false;
      if (!/^\d{4}-\d{2}-\d{2}$/.test(this.from_date) || !/^\d{4}-\d{2}-\d{2}$/.test(this.to_date)) {
        this.$bvToast.toast('Please set a valid date range', {
          title: `Failed`,
          variant: 'danger',
          solid: true
        });
      }
      if(this.employee_ids.length == 0)
      {
        if(flg == 1){
          this.$bvToast.toast('Please select employee(s) to download report', {
            title: `Failed`,
            variant: 'danger',
            solid: true
          });
        } else {
          this.$bvToast.toast('Please select employee(s) to generate report', {
            title: `Failed`,
            variant: 'danger',
            solid: true
          });
        }
        return;
      }
      if(flg == 1)
      {
        this.$bvToast.toast('We are downloading the report, this may take a while.', {
          title: `Hold Tight`,
          variant: 'info',
          solid: true
        });
      }

      let config = {};

      if(flg == 1)
      {
        config = {
          responseType: 'blob'
        }
      }

      this.loading = true;
      const formData = new FormData();
      formData.append("from_date", this.from_date);
      formData.append("to_date", this.to_date);
      formData.append("is_export", flg);
      formData.append('employee_ids', JSON.stringify(this.employee_ids));

      axios.post(this.$api_url + "/leave-attendance/monthly/summary", formData, config).then((response) => {
        if (flg == 1) {
          this.global_download_file_content(response);
        } else {
          this.rows = response.data;
          this.preview = true;
        }
        this.loading = false;
      }).catch((e) => {
        this.loading = false;
        this.serverError ? this.serverError(e) : console.log(e);
      });
    },
  },
  created() {
    this.getEmployees();
    this.getCompanyLeaveSettings();
  }
};
</script>
